export const ProgressBar = ({completed, required, type}) => {
  const percentage = required > 0 ? (completed / required) * 100 : 0;

  return (
    <div className='baseline-progress-bar-container'>
      <div className='baseline-progress-bar-track'>
        <div
          className={`baseline-progress-bar-fill ${type === 'pre' ? 'baseline-progress-bar-pre' : 'baseline-progress-bar-post'}`}
          style={{width: `${Math.min(percentage, 100)}%`}}
        />
      </div>
      <span className='baseline-progress-text'>
        {completed}/{required}
      </span>
    </div>
  );
};
